import Table from '@eduzz/houston-ui/Table';
import Tooltip from '@material-ui/core/Tooltip';
import MyIcon from 'components/Icon';
import Truncate from 'components/Truncate';
import { enums } from 'helpers';
import React, { useState } from 'react';
import { TableActionButton } from 'v2/components/Shared/TableActionButton';
import { useProductVariations } from 'v2/hooks/useProductVariations';

import type { IProduct } from 'v2/interfaces/product';

import { useStyles } from '../ProductTable/styles';
import ShowPrice from '../ShowPrice';

type DataChildrenProps = {
  product: IProduct;
  onClickOptions: (product: IProduct, activatedChildren: number) => void;
};

const DataChildren = ({ product, onClickOptions }: DataChildrenProps) => {
  const [shouldCallApi, setShouldCallApi] = useState(false);
  const classes = useStyles();

  const productVariationsQuery = useProductVariations(product.id, {
    enabled: shouldCallApi,
  });

  return (
    <Table.Collapse onOpen={() => setShouldCallApi(true)}>
      <Table total={productVariationsQuery.data?.length} className={classes.root} loading={productVariationsQuery.isLoading}>
        <Table.Header>
          <Table.Column>Produto</Table.Column>
          <Table.Column align='center'>Status</Table.Column>
          <Table.Column>Preço</Table.Column>
          <Table.Column></Table.Column>
        </Table.Header>
        <Table.Body>
          {productVariationsQuery.data?.map((variation: any, index: number) => (
            <Table.Row data={variation} index={index} key={variation.id}>
              <Table.Cell align='left' className='product__cell'>
                <div className='image' style={{ backgroundImage: `url(${variation.image})` }}></div>
                <div className='basic'>
                  <div className='title' title={variation.title || 'Desconhecido'}>
                    <Truncate count={80} final='...'>
                      {variation.title || 'Desconhecido'}
                    </Truncate>
                  </div>
                  {!variation.has_children && (
                    <div
                      className={`moderation__status ${enums.PRODUCT_STATUS_CLASS[variation.moderation_status ? variation.moderation_status : '']}`}
                    >
                      {enums.PRODUCT_STATUS[variation.moderation_status ? variation.moderation_status : 'Não definido']}

                      {variation.charge_type === 'A' && (
                        <Tooltip title='Recorrência' placement='top'>
                          <div className='charger-type'>
                            <MyIcon className='icon' name='icon-assinaturas' />
                          </div>
                        </Tooltip>
                      )}
                    </div>
                  )}
                </div>
              </Table.Cell>
              <Table.Cell className={variation.status === 'active' ? '--active' : '--inactive'} align='center'>
                {variation.status === 'active' ? 'Ativo' : 'Inativo'}
              </Table.Cell>
              <Table.Cell align='left'>
                <ShowPrice product={variation} commission='normal' />
              </Table.Cell>
              <Table.Cell align='right'>
                <TableActionButton onClick={() => onClickOptions(variation, productVariationsQuery.data?.length)} />
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Table.Collapse>
  );
};

export default DataChildren;
